import { createContext, useContext } from 'react';

/**
 * BottomSheet 内から「閉じる」を要求するための Context。
 * 子コンポーネントは useBottomSheetClose() でアクセスする。
 *
 * 背景タップと同じ扱いになるので、シート側が onBeforeClose を渡していれば
 * その判定（入力内容の破棄確認など）を通ってから閉じる。
 */
export const BottomSheetCloseContext = createContext<() => void>(() => {});

/** BottomSheet 内から閉じるよう要求するフック */
export const useBottomSheetClose = () => useContext(BottomSheetCloseContext);
